/** Preserve legacy string arguments while adding tenant-scoped reads to the same cache. */
export type RrcProfileId = string | { id: string; tenantCode?: string };
export type RrcProfileKey =
  | string
  | { profileKey: string; tenantCode?: string };
export const rrcProfileId = (arg: RrcProfileId) =>
  typeof arg === 'string' ? { id: arg } : arg;
export const rrcProfileKey = (arg: RrcProfileKey) =>
  typeof arg === 'string' ? { profileKey: arg } : arg;
